export function showNotication(instance, type, message) {
    instance.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 3000
    })
}
